exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* .card-body>>>table>tbody>tr>td {\n    cursor: pointer;\n}\n\ninput[type=\"texte\"] {\n    width: 100%;\n    padding: 12px 20px;\n    margin: 4px 0;\n    box-sizing: border-box;\n    border: none;\n    background-color: white;\n    color: white;\n} */\n", ""]);

// exports
